import {
  PartnerName,
  getPartnerName,
} from '../../core/partners/partner-registry';
import { JsonProperty } from '../../core/services/utils/mapping.service';
import { Department } from './department.model';
import { Entity } from './entity.model';

export class Customer extends Entity {
  @JsonProperty('name2')
  name2: string = '';
}

export class DetailedCustomer extends Customer {
  @JsonProperty({ clazz: Department, name: 'departments' })
  departments: Array<Department> = [];
  @JsonProperty('color')
  color: string = '';
  @JsonProperty('image')
  image: string = '';
  @JsonProperty()
  paymentMethod: string = '';
  @JsonProperty()
  partnerId?: number = 0;
  @JsonProperty()
  partnerLastSynchronization: string = '';
  @JsonProperty()
  partnerTokenGenerated: number = 0;
  @JsonProperty()
  ordersWithoutSepaAllowed: boolean = false;

  constructor(init?: Partial<DetailedCustomer>) {
    super();
    Object.assign(this, init);
  }

  /** The partner this record belongs to, or undefined if it has none. */
  get partnerName(): PartnerName | undefined {
    return getPartnerName(this.partnerId);
  }

  get isConnext(): boolean {
    return this.partnerName === PartnerName.Connext;
  }

  get isMyNeva(): boolean {
    return this.partnerName === PartnerName.Myneva;
  }

  get B2CDepartments() {
    return this.departments.filter(dept => !dept.isB2B);
  }

  get B2BDepartments() {
    return this.departments.filter(dept => dept.isB2B);
  }
}

export class ResidentsIban {
  @JsonProperty('signatureDate')
  signatureDate: string = '';
  @JsonProperty('bic')
  bic: string = '';
  @JsonProperty('iban')
  iban: string = '';
  @JsonProperty('name')
  name: string = '';
  @JsonProperty()
  sepaEmail?: string = '';
  @JsonProperty('country')
  country: string = '';
}

export interface IbanInUseCheck {
  inUse: boolean;
}
